// This file is auto-generated by running `yarn svg:process`
import { ChartLineUpSvg } from '~assets/svgs/ChartLineUp'
import { PersonSvg } from '~assets/svgs/person'
import { SvgShipDischarging } from '~assets/svgs/ship-discharging'
import { SvgShipDefault } from '~assets/svgs/ShipDefault'
import { SvgShipFixed } from '~assets/svgs/ShipFixed'
import { SvgShipLoading } from '~assets/svgs/ShipLoading'
import { SvgShipNoVoyage } from '~assets/svgs/ShipNoVoyage'
import { SvgShipWaiting } from '~assets/svgs/ShipWaiting'
import { SvgDenied } from '~assets/svgs/SvgDenied'
import { ArrowDownSvg } from './ArrowDown'
import { ArrowRightLongSvg } from './ArrowRightLong'
import { ArrowUpLongSvg } from './ArrowUpLong'
import { AttentionSvg } from './attention'
import { CalendarSvg } from './calendar'
import { CancelSvg } from './cancel'
import { ChevronDownSvg } from './ChevronDown'
import { ChevronLeftSvg } from './ChevronLeft'
import { ChevronRightSvg } from './ChevronRight'
import { CloseSvg } from './close'
import { CogSvg } from './cog'
import { ConfirmSvg } from './confirm'
import { ContainerShipSvg } from './ContainerShip'
import { CopySvg } from './copy'
import { CopyClipboardSvg } from './copy-clipboard'
import { DocumentSvg } from './document'
import { DownloadSvg } from './download'
import { DropSvg } from './drop'
import { ExportSvg } from './export'
import { IconAnchorSvg } from './IconAnchor'
import { IconCheckCircleSvg } from './IconCheckCircle'
import { IconCommentsSvg } from './IconComments'
import { IconHeartSvg } from './IconHeart'
import { IconLightBulbSvg } from './IconLightBulb'
import { IconLinkSvg } from './IconLink'
import { IconShareSvg } from './IconShare'
import { IconThumbsUpSvg } from './IconThumbsUp'
import { InfoSvg } from './info'
import { InvisibleSvg } from './invisible'
import { LargeCheckmarkSvg } from './LargeCheckmark'
import { PaymentSvg } from './payment'
import { PenSvg } from './pen'
import { PlusSvg } from './plus'
import { SearchSvg } from './search'
import { SecureSvg } from './secure'
import { SquaredAttentionSvg } from './SquaredAttention'
import { StarSvg } from './star'
import { StarFilledSvg } from './StarFilled'
import { TaskSvg } from './task'
import { TrashSvg } from './trash'
import { UserSvg } from './user'
import { VesselFrontSvg } from './VesselFront'
import { VisibleSvg } from './visible'
import { WarningSvg } from './warning'

export const iconsMap = {
  exportIcon: ExportSvg,
  arrowDown: ArrowDownSvg,
  arrowRightLong: ArrowRightLongSvg,
  arrowUpLong: ArrowUpLongSvg,
  attention: AttentionSvg,
  squaredAttention: SquaredAttentionSvg,
  calendar: CalendarSvg,
  cancel: CancelSvg,
  chevronDown: ChevronDownSvg,
  chevronLeft: ChevronLeftSvg,
  chevronRight: ChevronRightSvg,
  close: CloseSvg,
  cog: CogSvg,
  confirm: ConfirmSvg,
  containerShip: ContainerShipSvg,
  copy: CopySvg,
  copyClipboard: CopyClipboardSvg,
  document: DocumentSvg,
  download: DownloadSvg,
  drop: DropSvg,
  iconAnchor: IconAnchorSvg,
  iconCheckCircle: IconCheckCircleSvg,
  iconComments: IconCommentsSvg,
  iconHeart: IconHeartSvg,
  iconLightBulb: IconLightBulbSvg,
  iconLink: IconLinkSvg,
  iconShare: IconShareSvg,
  iconThumbsUp: IconThumbsUpSvg,
  info: InfoSvg,
  invisible: InvisibleSvg,
  largeCheckmark: LargeCheckmarkSvg,
  payment: PaymentSvg,
  pen: PenSvg,
  plus: PlusSvg,
  search: SearchSvg,
  secure: SecureSvg,
  vesselFront: VesselFrontSvg,
  starFilled: StarFilledSvg,
  star: StarSvg,
  task: TaskSvg,
  trash: TrashSvg,
  user: UserSvg,
  visible: VisibleSvg,
  warning: WarningSvg,
  person: PersonSvg,
  chartLineUp: ChartLineUpSvg,
  shipCommencing: SvgShipDefault,
  shipFueling: SvgShipLoading,
  shipLoading: SvgShipLoading,
  shipWaiting: SvgShipWaiting,
  shipDischarging: SvgShipDischarging,
  shipClosed: SvgShipNoVoyage,
  shipCompleted: SvgShipNoVoyage,
  shipOther: SvgShipDefault,
  shipCanalTransit: SvgShipWaiting,
  shipRepair: SvgShipWaiting,
  shipCharterersOrders: SvgShipFixed,
  shipTerminating: SvgShipNoVoyage,
  shipDelivery: SvgShipDischarging,
  shipForOrders: SvgShipDefault,
  shipMultiPurpose: SvgShipDefault,
  shipRedelivery: SvgShipDischarging,
  shipPassing: SvgShipDefault,
  denied: SvgDenied,
}
